// Template Generated by DataExtraction.py at 1716507313

import EnglishReg1 from "../../Forms/KYC2/English_Reg-1.png";
import EnglishReg1Labels from "../../Labels/KYC2/English_Reg-1.json";
import FrenchReg1 from "../../Forms/KYC2/French_Reg-1.png";
import FrenchReg1Labels from "../../Labels/KYC2/French_Reg-1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab,
    formatDayFromDate,
    formatMonthFromDate,
    formatYearFromDate,
    drawText as drawTextAtPos,
} from "../../PDFGenerationUtils";
import { PLAN_TYPES, POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import {
    calculateAgeOfYoungestBeneficiary,
    calculateApproximateNetWorth,
    calculateMaxEducationSavingsPlans,
    calculateMonthlyDisposableIncome,
    calculateMonthlyIncomeGross,
    calculateMonthlyIncomeNet,
    calculateTimeHorizon,
    calculateTotalFinancialAssets,
    calculateTotalInvestmentAssets,
    calculateTotalMonthlyExpenses,
    calculateTotalOtherAssets,
    calculateYearlyIncomeGross,
    isDisposableIncomeExceeded,
    isEightyYearRuleExceeded,
    isKnowYourClientFormComplete,
} from "../../../Utils/KYCUtils";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchReg1Labels : EnglishReg1Labels;
    const formImage = isFrench ? FrenchReg1 : EnglishReg1;

    function fillCheckbox(value, label) {
        drawTextOnLabel(doc, value ? t("Yes") : t("No"), label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    // add image
    doc.addImage(
        formImage,
        standardFormFormat,
        labels["image"]["x"],
        labels["image"]["y"],
        labels["image"]["width"],
        labels["image"]["height"],
        null,
        standardFormCompression,
    );

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
     */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;

    const application = data.application;

    const planTypeID = plan.planTypeID;

    const subscriber2Include = common.subscriber2Include;

    const s1Email = subscriber.email;
    const s2Email = jointSubscriber.email;

    const s1Name =
        subscriber.firstName +
        (subscriber.lastName ? " " + subscriber.lastName : "");
    const s2Name =
        jointSubscriber.firstName +
        (jointSubscriber.lastName ? " " + jointSubscriber.lastName : "");

    const d1 = data.dependant;
    const d2 = data.dependant2;
    const d3 = data.dependant3;
    const d4 = data.dependant4;
    const d5 = data.dependant5;

    const beneficiary = data.beneficiary;

    const dateFormat = "MM/DD/yyyy";

    const planTypeMappings = {
        "-1": "",
        0: "Group",
        1: "Self-Initiated",
        2: "Achievers",
    };

    const planType = planTypeMappings[planTypeID];

    const {
        monthlyMaximumEducationSavingsPlan,
        monthlyMaximumEducationSavingsPlanGroup,
    } = calculateMaxEducationSavingsPlans(subscriber, jointSubscriber, kyc);

    // Drawing the form
    // TODO in the ipad if monthlyExpensesTotal is 0 then things should be hidden per ln 587 of KYCSViewController.m

    if (planTypeID === 0) {
        // Group
        drawText("(H)", "affordabilityGroup", null, true);
        drawText(t("Yes"), "affordabilityYesNo");
    } else if (planTypeID === 1) {
        // Self-Initiated
        // drawText("affordabilitySelfInitiated", "affordabilitySelfInitiated"); // doesn't exist
        drawText(t("No"), "affordabilityYesNo");
    } else if (planTypeID === 2) {
        // Achievers
        drawText(t("Yes"), "affordabilityYesNo");
        drawText("(H)", "affordabilityAchievers", null, true);
    }

    drawText(
        displayCurrency(calculateApproximateNetWorth(kyc), i18n.language),
        "netWorth",
    );
    drawText(
        displayCurrency(kyc.cashAndLiquid, i18n.language),
        "cashAndLiquid",
    );
    drawText(
        displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language),
        "ccbGross",
    );
    drawText(
        displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language),
        "ccbNet",
    );
    drawText(displayCurrency(kyc.childCare, i18n.language), "childCare");
    drawText(displayCurrency(kyc.clothing, i18n.language), "clothing");

    drawText(displayCurrency(kyc.deposits, i18n.language), "deposits");
    drawText(
        displayCurrency(
            calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "disposableIncome",
        calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc) < 0
            ? {
                r: 255,
                g: 0,
                b: 0,
                a: 255,
            }
            : null,
    );

    drawText(
        isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc)
            ? t("Disposable Income Exceeded")
            : "",
        "diExceeded",
        isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc)
            ? {
                r: 255,
                g: 0,
                b: 0,
                a: 255,
            }
            : null,
    );
    drawText(
        isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common)
            ? t("Note deposit schedule and subscriber's 80th birthday")
            : "",
        "eightyYearRule",
        isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common)
            ? {
                r: 255,
                g: 0,
                b: 0,
                a: 255,
            }
            : null,
    );

    if (
        !isKnowYourClientFormComplete(subscriber, jointSubscriber, kyc, common)
    ) {
        drawText(t("Form Incomplete"), "formIncomplete", {
            r: 255,
            g: 0,
            b: 0,
            a: 255,
        });
    }
    drawText(isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? t("Disposable Income Exceeded") : "", "diExceeded", isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);
    drawText(isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? t("Note deposit schedule and subscriber's 80th birthday") : "", "eightyYearRule", isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);

    drawText(displayCurrency(kyc.groceries, i18n.language), "groceries");
    drawText(displayCurrency(kyc.insurance, i18n.language), "insurance");
    drawText(
        displayCurrency(kyc.collectablesArtValuables, i18n.language),
        "collectablesArtValuables",
    );

    drawText(displayCurrency(kyc.liabilities, i18n.language), "liabilities");

    if (planTypeID === 0) {
        // GROUP
        drawText(
            "N/A",
            "maximumEsp",
            null,
            true,
        );
        drawText(
            displayCurrency(monthlyMaximumEducationSavingsPlanGroup, i18n.language),
            "maximumEspGroup",
            null,
            true,
        );
    } else if (planTypeID === 1) {
        // SI
        drawText(
            "N/A",
            "maximumEsp",
            null,
            true,
        );
        drawText(
            "N/A",
            "maximumEspGroup",
            null,
            true,
        );
    } else if (planTypeID === 2) {
        // ACHIEVERS
        drawText(
            displayCurrency(monthlyMaximumEducationSavingsPlan),
            "maximumEsp",
            null,
            true,
        );
        drawText(
            "N/A",
            "maximumEspGroup",
            null,
            true,
        );
    }
    drawText(
        displayCurrency(kyc.investmentAssetsOther, i18n.language),
        "investmentAssetsOther",
    );

    drawText(
        displayCurrency(kyc.miscellaneous, i18n.language),
        "miscellaneous",
    );
    drawText(
        displayCurrency(kyc.morgageCondoFeesRent, i18n.language),
        "mortgage",
    );

    drawText(displayCurrency(kyc.otherAssets, i18n.language), "otherAssets");
    drawText(
        displayCurrency(kyc.otherAssetsVehicles, i18n.language),
        "otherAssetsVehicles",
    );
    drawText(
        displayCurrency(kyc.otherRealEstateEquity, i18n.language),
        "otherRealEstateEquity",
    );
    drawText(
        displayCurrency(kyc.otherContractualObligations, i18n.language),
        "otherContractualObligations",
    );
    drawText(
        displayCurrency(kyc.otherMonthlyIncomeGross, i18n.language),
        "otherGross",
    );
    drawText(
        displayCurrency(kyc.otherMonthlyIncomeNet, i18n.language),
        "otherNet",
    );
    drawText(
        displayCurrency(kyc.paymentOnLoansAndDebts, i18n.language),
        "paymentsOnLoansAndDebts",
    );
    drawText(t(planType), "planType");
    drawText(
        displayCurrency(kyc.principalResidenceEquity, i18n.language),
        "principalResidenceEquity",
    );
    drawText(
        displayCurrency(kyc.registeredAccountsRESPAndTFSA, i18n.language),
        "registeredAccountsRESPAndTFSA",
    );
    drawText(
        displayCurrency(kyc.RegisteredAccountsRESPs, i18n.language),
        "RegisteredAccountsRESPs",
    );
    drawText(t(kyc.riskTolerance), "riskTolerance");

    drawText(formatDayFromDate(subscriber.birthdate), "s1DobDay");
    drawText(formatMonthFromDate(subscriber.birthdate), "s1DobMonth");
    drawText(formatYearFromDate(subscriber.birthdate), "s1DobYear");
    drawText(subscriber.employer, "s1Employer");
    drawText(
        displayCurrency(subscriber.monthlyIncomeGross, i18n.language),
        "s1Gross",
    );
    drawText(t(subscriber.investmentExperience), "s1InvestmentExperience");
    // drawText(subscriber.investmentTypes, "s1InvestmentTypes");
    drawText(s1Name, "s1Name");
    drawText(s1Email, "s1Email");
    drawText(
        displayCurrency(subscriber.monthlyIncomeNet, i18n.language),
        "s1Net",
    );
    drawText(subscriber.occupation, "s1Occupation");
    if (subscriber2Include) {
        drawText(formatDayFromDate(jointSubscriber.birthdate), "s2DobDay");
        drawText(formatMonthFromDate(jointSubscriber.birthdate), "s2DobMonth");
        drawText(formatYearFromDate(jointSubscriber.birthdate), "s2DobYear");
        drawText(jointSubscriber.employer, "s2Employer");
        drawText(
            displayCurrency(jointSubscriber.monthlyIncomeGross, i18n.language),
            "s2Gross",
        );
        drawText(
            t(jointSubscriber.investmentExperience),
            "s2InvestmentExperience",
        );

        //TODO this is broken in french! s2InvestmentTypes is not found in labels
        drawText(jointSubscriber.investmentTypes, "s2InvestmentTypes");

        drawText(s2Name, "s2Name");
        drawText(s2Email, "s2Email");
        drawText(
            displayCurrency(jointSubscriber.monthlyIncomeNet, i18n.language),
            "s2Net",
        );
        drawText(jointSubscriber.occupation, "s2Occupation");
    }
    drawText(displayCurrency(kyc.securities, i18n.language), "securities");
    drawText(application.tcpEmail, "tcpEmail");
    drawText(application.tcpName, "tcpName");
    drawText(application.tcpPhone, "tcpPhone");
    drawText(application.tcpRelationship, "tcpRelationship");
    drawText(
        displayCurrency(calculateTotalMonthlyExpenses(kyc), i18n.language),
        "totalExpenses",
    );
    drawText(
        displayCurrency(calculateTotalFinancialAssets(kyc), i18n.language),
        "totalFinancialAssets",
    );
    drawText(
        displayCurrency(calculateTotalInvestmentAssets(kyc), i18n.language),
        "totalInvestmentAssets",
    );
    drawText(
        displayCurrency(
            calculateMonthlyIncomeGross(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "totalGross",
    );
    drawText(
        displayCurrency(
            calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "totalNet",
    );
    drawText(
        displayCurrency(kyc.transportation, i18n.language),
        "transportation",
    );
    drawText(
        displayCurrency(calculateTotalOtherAssets(kyc), i18n.language),
        "totalOtherAssets",
    );
    drawText(displayCurrency(kyc.utilities, i18n.language), "utilities");
    drawText(kyc.vehicles, "vehicles");
    drawText(
        displayCurrency(
            calculateYearlyIncomeGross(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "yearlyIncomeGross",
    );
};

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchReg1Labels : EnglishReg1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS["Dealing Representative"];
    const subscriberRecipientId = POSSIBLE_SIGNERS["Subscriber"];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS["Joint Subscriber"];
    let signers = [];
    let signHereTabs = [];

    return signers;
};

export default {
    generate,
    signatureDefinitions,
};
